import {
  BUILDING_ENTITY,
  BUILDING_GROUP_ENTITY,
  CHAT_ENTITY,
  CONTRACT_ENTITY,
  DOC_FLOW_ENTITY,
  DOCUMENTS_ENTITY,
  EMAIL_ENTITY,
  FLAT_ENTITY,
  INHABITANT_ENTITY,
  LABEL_ENTITY,
  NEWSBOARD_ENTITY,
  PROVIDER_ENTITY,
  RENTAL_LISTING_ENTITY,
  REQUEST_ENTITY,
  SINGLE_EMAIL_ENTITY,
  STAFF_MEMBER_REQUEST_CATEGORIES_ENTITY,
  TASK_ENTITY,
} from './entity'

export const API_PARAM_IS_REDESIGN_CONTEXT = 'is_redesign_context'

export const BUILDING_LIST_API =
  'idwell-api/api/v3/construction/buildings/filter/'

export const BUILDING_SINGLE_FIELD_API =
  'idwell-api/api/v3/construction/buildings/single-field/'

export const BUILDING_GROUP_LIST_API =
  'idwell-api/api/v3/construction/building-groups/filter/'

export const BUILDING_SHORT_LIST_API =
  'idwell-api/api/v3/construction/buildings/list/'

export const DOCUMENTS_LIST_API = 'api/v4/file/filter/'

export const EMAILS_LIST_API = 'idwell-api/api/v3/email/email-threads/filter/'

export const SINGLE_EMAILS_LIST_API =
  'idwell-api/api/v3/email/no-thread-view-email-messages/filter/'

export const EMAIL_MESSAGES_SEARCH_API =
  'idwell-api/api/v3/email/email-messages/search/'

export const FLAT_LIST_API = 'idwell-api/api/v3/construction/flats/filter/'

export const INHABITANT_LIST_API =
  'idwell-api/api/v3/inhabitancy/inhabitants/filter/'

export const INHABITANT_SHORT_LIST_API =
  'idwell-api/api/v3/inhabitancy/inhabitants/list/'

export const INHABITANT_SINGLE_FIELD_API =
  'idwell-api/api/v3/inhabitancy/inhabitants/single-field/'

export const INHABITANT_CONTRACT_LIST_API =
  'idwell-api/api/v3/inhabitancy/inhabitant-contracts/filter/'

export const NEWSBOARD_LIST_API = '/idwell-api/api/v3/news/posts/filter/'

export const REQUEST_LIST_API = 'idwell-api/api/v3/request/requests/filter/'

export const REQUEST_LIST_COUNT_API =
  'idwell-api/api/v3/request/requests/filter/count/'

export const REQUEST_SINGLE_FIELD_API =
  'idwell-api/api/v3/request/request-single-field/'

export const REQUEST_CATEGORY_LIST_API =
  'idwell-api/api/v3/request/request-categories/filter/'

export const REQUEST_CATEGORY_SINGLE_FIELD_API =
  'idwell-api/api/v3/request/request-categories/single-field/'

export const TARIFFS_LIMITS_ADD_ONS_TABLE_CONFIG_API =
  'idwell-api/api/v3/table/tables/settings-tariffs-overrides/'

export const TASKS_LIST_API = 'idwell-api/api/v3/pipeline/activities/filter/'

export const PROVIDERS_LIST_API =
  'idwell-api/api/v3/contractor/contractors/filter/'

export const DOCUMENT_STAPLINGS_LIST_API =
  'api/document-stapling/document-staplings/filter/'

export const CHATS_LIST_API = 'idwell-api/api/v3/chat/chats/filter/'

export const LABELS_LIST_API = 'idwell-api/api/v3/customization/labels/filter/'

export const CONTRACT_LIST_API =
  'idwell-api/api/v3/inhabitancy/contracts/filter/'

export const CONTRACT_SINGLE_FIELD_API =
  'idwell-api/api/v3/inhabitancy/contracts/single-field/'

export const RENTAL_PORTAL_LISTINGS_LIST_API =
  'idwell-api/api/v3/rental-portal/listings/filter/'

export const REQUEST_API_ALIASES = {
  [BUILDING_ENTITY.single]: {
    listApi: BUILDING_LIST_API,
  },
  [BUILDING_GROUP_ENTITY.single]: {
    listApi: BUILDING_GROUP_LIST_API,
  },
  [CHAT_ENTITY.single]: {
    listApi: CHATS_LIST_API,
  },
  [CONTRACT_ENTITY.single]: {
    listApi: CONTRACT_LIST_API,
  },
  [DOC_FLOW_ENTITY.single]: {
    listApi: DOCUMENT_STAPLINGS_LIST_API,
  },
  [DOCUMENTS_ENTITY.single]: {
    listApi: DOCUMENTS_LIST_API,
  },
  [EMAIL_ENTITY.single]: {
    listApi: EMAILS_LIST_API,
  },
  [FLAT_ENTITY.single]: {
    listApi: FLAT_LIST_API,
  },
  [INHABITANT_ENTITY.single]: {
    listApi: INHABITANT_LIST_API,
  },
  [LABEL_ENTITY.single]: {
    listApi: LABELS_LIST_API,
  },
  [NEWSBOARD_ENTITY.single]: {
    listApi: NEWSBOARD_LIST_API,
  },
  [PROVIDER_ENTITY.single]: {
    listApi: PROVIDERS_LIST_API,
  },
  [RENTAL_LISTING_ENTITY.single]: {
    listApi: RENTAL_PORTAL_LISTINGS_LIST_API,
  },
  [REQUEST_ENTITY.single]: {
    countApi: REQUEST_LIST_COUNT_API,
    listApi: REQUEST_LIST_API,
  },
  [SINGLE_EMAIL_ENTITY.single]: {
    listApi: SINGLE_EMAILS_LIST_API,
  },
  [STAFF_MEMBER_REQUEST_CATEGORIES_ENTITY.single]: {
    listApi: REQUEST_CATEGORY_LIST_API,
  },
  [TASK_ENTITY.single]: {
    listApi: TASKS_LIST_API,
  },
}

export const HTTP_STATUS_OK = 200

export const HTTP_STATUS_CREATED = 201

export const HTTP_STATUS_ACCEPTED = 202

export const HTTP_STATUS_NON_AUTHORITATIVE_INFORMATION = 203

export const HTTP_STATUS_NO_CONTENT = 204

export const HTTP_STATUS_RESET_CONTENT = 205

export const HTTP_STATUS_PARTIAL_CONTENT = 206

export const HTTP_STATUS_MULTI_STATUS = 207

export const HTTP_STATUS_ALREADY_REPORTED = 208

export const HTTP_STATUS_IM_USED = 226

export const HTTP_STATUS_BAD_REQUEST = 400

export const HTTP_STATUS_UNAUTHORIZED = 401

export const HTTP_STATUS_PAYMENT_REQUIRED = 402

export const HTTP_STATUS_FORBIDDEN = 403

export const HTTP_STATUS_NOT_FOUND = 404

export const HTTP_STATUS_METHOD_NOT_ALLOWED = 405

export const HTTP_STATUS_CONFLICT = 409

export const HTTP_STATUS_GONE = 410

export const HTTP_STATUS_PAYLOAD_TOO_LARGE = 413

export const HTTP_STATUS_IM_A_TEAPOT = 418

export const HTTP_STATUS_UNPROCESSABLE_ENTITY = 422

export const HTTP_STATUS_UNAVAILABLE = 424

export const HTTP_STATUS_TOO_MANY_REQUESTS = 429

export const HTTP_STATUS_INTERNAL_SERVER_ERROR = 500

export const HTTP_STATUS_BAD_GATEWAY_ERROR = 502

export const HTTP_STATUS_SERVICE_UNAVAILABLE = 503

export const API_ERROR_CODE_CONNECTION_ABORTED = 'ECONNABORTED'

export const API_ERROR_CODE_TIMEOUT = 'ETIMEDOUT'

export const API_TIMEOUT_ERROR_CODES = [
  API_ERROR_CODE_CONNECTION_ABORTED,
  API_ERROR_CODE_TIMEOUT,
]

export const SUCCESS_CODES = [
  HTTP_STATUS_OK,
  HTTP_STATUS_CREATED,
  HTTP_STATUS_ACCEPTED,
  HTTP_STATUS_NON_AUTHORITATIVE_INFORMATION,
  HTTP_STATUS_NO_CONTENT,
  HTTP_STATUS_RESET_CONTENT,
  HTTP_STATUS_PARTIAL_CONTENT,
  HTTP_STATUS_MULTI_STATUS,
  HTTP_STATUS_ALREADY_REPORTED,
  HTTP_STATUS_IM_USED,
]

export const PRINTER_API = 'api/printer/'
